import cn from "classnames";
import Styles from "./SearchResults.module.scss";
import { Text } from "src/components/atoms/Text/Text";
import { LayoutList } from "../LayoutList/LayoutList";
import * as Eden from "src/eden/content";

interface SearchResultsProps {
  results: Eden.SearchResults;
  handleImport: (id: Eden.SearchResult) => void;
}

export const SearchResults = ({ results, handleImport }: SearchResultsProps) => {
  const totalHits = results.hits.length > 0 ? results.total_count + " results" : "";

  return (
    <div className={Styles.wrapper}>
      <Text className={cn(Styles.totalCount)} color="cool-grey-dark" size="small" block={true}>
        {totalHits}
      </Text>
      <LayoutList results={results} handleImport={handleImport} />
    </div>
  );
};
